import { IValidation } from "@cak-legacy/generation-core";
import { ValidationBuilder } from "../builder/validationBuilder";
import { AbstractFieldModel } from "../client/model/fields/abstractFieldModel";
import { ValidateField } from "../client/model/validation/validateField";

export const convertValidate = (field: AbstractFieldModel, type: string): IValidation[] => {
  if (!field.validate && !field.onChange) return [];
  let validationBuilder = new ValidationBuilder(type);
  const validate = field.validate || ([] as ValidateField);
  if (field.onChange) {
    validationBuilder = validationBuilder.addEqualsValueValidation(
      `${field.onChange.propertyPath}.${field.onChange.validSearchResultPropertyName}`,
      "true",
      (label: string) => `Er is geen resultaat gevonden voor "${label}"`
    );
  }
  return createValidations(validationBuilder, validate);
};

export const createValidations = (validationBuilder: ValidationBuilder, validate: ValidateField) => {
  return validationBuilder
    .addIsRequired(validate.isRequired)
    .addMaxLengthValidation(validate.maxLength, validate.limitMaxLengthOnInputs)
    .addDateRangeValidation(validate.dateRangeValidation)
    .addNoFutureDateValidation(validate.noFutureDateValidation)
    .addBSNValidation(validate.bsnValidation)
    .addRegexValidation(validate.regex)
    .addGreaterThanValueValidation(validate.greaterThanValue)
    .addGreaterThanOrEqualValueValidation(validate.greaterThanOrEqualToValue)
    .addSmallerThanValueValidation(validate.smallerThanValue)
    .addSmallerThanOrEqualValueValidation(validate.smallerThanOrEqualToValue)
    .addCompareValidation(validate.compare)
    .addMinimumDateValidation(validate.minimumDate)
    .addIbanValidation(validate.ibanValidation)
    .addEmailValidation(validate.emailValidation)
    .addPhoneValidation(validate.phoneValidation)
    .addKvkValidation(validate.kvkValidation)
    .build();
};
